import axios from 'axios';
import { handleAxiosError } from 'core/notifications';

/* eslint-disable camelcase */
export default async ({ id }) => {
  let agenda_items = [];

  try {
    ({ data: { data: { agenda_items } } } = await axios.get(`/api/learner/live_videos/${id}/agenda`));
  } catch (error) {
    if (error.response?.status !== 401) {
      handleAxiosError(error);
    }
  }

  return agenda_items;
};
